import {useState} from "react";
import {
    FILTER_KEY_CRYPTO,
    FILTER_KEY_FUNDS,
    FILTER_KEY_REAL_ESTATE,
    FILTER_KEY_STOCKS,
    FILTER_KEY_STOCKS_UNLISTED,
} from "../../../ducks/assets-duck.js";
import NorwaySvg from "../../../icons/norway-flag-circle.svg";
import EuSvg from "../../../icons/eu-flag-circle.svg";
import AsiaSvg from "../../../icons/asia.svg";
import WorldSvg from "../../../icons/world-circle.svg";
import EmergingSvg from "../../../icons/emerging-markets-sprout.svg";
import InterestSvg from "../../../icons/interest-bonds-circle.svg";
import OdfjellSvg from "../../../icons/odfjell-circle.svg";
import KongsbergSvg from "../../../icons/kongsberg-circle.svg";
import VolkswagenSvg from "../../../icons/volkswagen-circle.svg";
import AmundiSvg from "../../../icons/amundi-circle.svg";
import ProSharesSvg from "../../../icons/proshares-circle.svg";
import AlphabetSvg from "../../../icons/alphabet-circle.svg";
import MetaSvg from "../../../icons/meta-circle.svg";
import NintendoSvg from "../../../icons/nintendo-circle.svg";
import NortunaSvg from "../../../icons/nortuna-circle.svg";
import SkytechSvg from "../../../icons/skytech-circle.svg";
import GenericCompanySvg from "../../../icons/generic-company-circle.svg";
import BitcoinSvg from "../../../icons/bitcoin-circle.svg";
import EthereumSvg from "../../../icons/ethereum-circle.svg";
import RocketPoolSvg from "../../../icons/rocketpool-circle.svg";
import SolanaSvg from "../../../icons/solana-circle.svg";
import AaveSvg from "../../../icons/aave-circle.svg";
import AjnaSvg from "../../../icons/ajna-circle.svg";
import GenericCryptoSvg from "../../../icons/generic-crypto-circle.svg";
import RealEstateSvg from "../../../icons/real-estate-circle.svg";
import './AssetListIcon.scss'

const ICON_GROUPS = {
    [FILTER_KEY_FUNDS]: {
        fallback: {icon: WorldSvg, name: 'World'},
        icons: [
            {icon: NorwaySvg, name: 'Norway', keywords: ['norge', 'norway', 'norsk']},
            {icon: EuSvg, name: 'Europe', keywords: ['europa', 'europe']},
            {icon: AsiaSvg, name: 'Asia', keywords: ['asia']},
            {icon: EmergingSvg, name: 'Emerging Markets', keywords: ['emerging', 'fremvoksende']},
            {icon: InterestSvg, name: 'Interest', keywords: ['rente', 'high yield']},
            {icon: WorldSvg, name: 'World', keywords: ['global indeks 125'], iconClassName: 'is-variant'},
        ],
    },
    [FILTER_KEY_STOCKS]: {
        fallback: {icon: GenericCompanySvg, name: 'Company'},
        icons: [
            {icon: OdfjellSvg, name: 'Odfjell', keywords: ['odfjell']},
            {icon: KongsbergSvg, name: 'Kongsberg', keywords: ['kongsberg']},
            {icon: VolkswagenSvg, name: 'Volkswagen', keywords: ['volkswagen']},
            {icon: AmundiSvg, name: 'Amundi', keywords: ['amundi']},
            {icon: ProSharesSvg, name: 'ProShares', keywords: ['proshares']},
            {icon: AlphabetSvg, name: 'Alphabet', keywords: ['alphabet', 'google']},
            {icon: MetaSvg, name: 'Meta', keywords: ['meta', 'facebook']},
            {icon: NintendoSvg, name: 'Nintendo', keywords: ['nintendo']},
            {icon: NortunaSvg, name: 'Nortuna', keywords: ['nortuna']},
            {icon: SkytechSvg, name: 'Skytech', keywords: ['skytech']},
        ],
    },
    [FILTER_KEY_CRYPTO]: {
        fallback: {icon: GenericCryptoSvg, name: 'Crypto'},
        icons: [
            {icon: BitcoinSvg, name: 'Bitcoin', keywords: ['bitcoin', 'btc']},
            {icon: RocketPoolSvg, name: 'Rocket Pool ETH', keywords: ['rocket pool', 'rocketpool', 'reth']},
            {icon: EthereumSvg, name: 'Ethereum', keywords: ['ethereum']},
            {icon: SolanaSvg, name: 'Solana', keywords: ['solana']},
            {icon: AaveSvg, name: 'Aave', keywords: ['aave']},
            {icon: AjnaSvg, name: 'Ajna', keywords: ['ajna']},
        ],
    },
    [FILTER_KEY_REAL_ESTATE]: {
        fallback: {icon: RealEstateSvg, name: 'Real estate'},
        icons: [],
    },
}

ICON_GROUPS[FILTER_KEY_STOCKS_UNLISTED] = ICON_GROUPS[FILTER_KEY_STOCKS]

export default ({name = '', assetGroup, className = ''}) => {
    const [isLoaded, setIsLoaded] = useState(false)
    const group = ICON_GROUPS[assetGroup] || ICON_GROUPS[FILTER_KEY_REAL_ESTATE]
    const nameLowerCaps = name.toLowerCase()
    const match = group.icons.find(({keywords}) => keywords.some(keyword => nameLowerCaps.includes(keyword)))
    const {icon, name: alt, iconClassName = ''} = match || group.fallback

    return (
        <img
            src={icon}
            alt={alt}
            onLoad={() => setIsLoaded(true)}
            ref={img => img?.complete && !isLoaded && setIsLoaded(true)}
            className={`asset-list-icon ${isLoaded ? 'is-loaded' : ''} ${iconClassName} ${className}`}
        />
    )
}
